/* eslint-disable no-console */
class GiftingDrawer extends window.BAO.CustomElement() {
  connectedCallback () {
    this.shouldFocusNote = false

    this.handleEditTrigger = this.handleEditTrigger.bind(this)
    this.focusNote = this.focusNote.bind(this)
    this.setupListeners()
    this.syncQuantitiesFromCart()
  }

  handleEditTrigger (event) {
    if (event.target.closest('[data-gifting-options-external-el="editTrigger"]')) {
      this.shouldFocusNote = true
    }
  }

  focusNote () {
    if (!this.shouldFocusNote || window.drawers?.activeDrawerKey !== 'gifting-drawer') return

    this.shouldFocusNote = false

    window.requestAnimationFrame(() => {
      if (window.drawers?.activeDrawerKey !== 'gifting-drawer') return

      const note = this.querySelector('textarea[name="note"]')

      if (note) {
        note.focus()
        note.setSelectionRange(note.value.length, note.value.length)
      }
    })
  }

  setupListeners () {
    this.listeners.add(document, 'click', this.handleEditTrigger, true)
    this.listeners.add(document, 'drawer-changed', this.focusNote)
    this.listeners.add(
      window.BAO.eventBus,
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      () => this.syncQuantitiesFromCart(),
    )

    this.els.item.elements.forEach((item) => {
      const quantityAdjuster = item.querySelector('quantity-adjuster')

      quantityAdjuster?.addEventListener(window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE, () => {
        this.updatePushCartGiftingState()
      })
    })

    if (this.els.submit.element) {
      this.listeners.add(this.els.submit.element, 'click', (event) => {
        event.preventDefault()
        this.saveItems()
      })
    }

    if (this.els.note.element) {
      this.listeners.add(this.els.note.element, 'input', () => {
        this.updatePushCartGiftingState()
      })
    }

    this.updatePushCartGiftingState()
  }

  updatePushCartGiftingState () {
    const intro = document.querySelector('.pcg-GiftingInto')
    const update = document.querySelector('.pcg-GiftingInto-update')
    const note = this.els.note.element
    const hasGiftItem = this.els.item.elements
      .some((item) => Number(item.querySelector('[data-quantity-adjuster-el="input"]')?.value) > 0)
    const hasNote = Boolean(note?.value.trim())
    const hasGifting = hasGiftItem || hasNote

    if (intro) intro.hidden = hasGifting
    if (update) update.hidden = !hasGifting
  }

  async syncQuantitiesFromCart () {
    if (!this.els.item.exists) return

    const cart = await window.BAO.Utils.fetchJSON('/cart.json')
    const quantitiesByVariant = new Map()

    ;(cart?.items || []).forEach((cartItem) => {
      const variantId = Number(cartItem.variant_id)
      const quantity = Number(cartItem.quantity)

      if (!Number.isFinite(variantId) || !Number.isFinite(quantity)) return

      quantitiesByVariant.set(
        variantId,
        (quantitiesByVariant.get(variantId) || 0) + quantity,
      )
    })

    this.els.item.elements.forEach((item) => {
      const variantId = Number(item.dataset.variantId)
      const quantityAdjuster = item.querySelector('quantity-adjuster')

      if (!quantityAdjuster || !Number.isFinite(variantId)) return

      quantityAdjuster.value = quantitiesByVariant.get(variantId) || 0
    })

    this.updatePushCartGiftingState()
  }

  async submitNote () {
    const noteForm = this.querySelector('.gft-GiftItems_Note')
    if (!noteForm) return

    const note = this.els.note.element?.value.trim() || ''
    const pushCart = document.querySelector('push-cart')

    window.drawers.activeDrawerKey = 'cart'
    if (pushCart) pushCart.loading = true

    try {
      const state = await window.BAO.Utils.fetchJSON('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({
          note,
          sections: window.BAO.Cart.getDefaultSections(),
          sections_url: window.location.pathname,
        }),
      })

      if (pushCart && state?.sections) {
        pushCart.renderSections(state.sections)
      }

      window.BAO.dispatchEvent(window.BAO.EVENTS.PUSH_CART.CHANGED, {
        state,
      })
    } finally {
      if (pushCart) pushCart.loading = false
    }
  }

  async saveItems () {
    try {
      const cart = await window.BAO.Utils.fetchJSON('/cart.json')
      const cartItems = cart?.items || []
      const itemsToAdd = []
      const itemsToUpdate = []
      const itemsToRemove = []

      this.els.item.elements.forEach((item) => {
        const variantId = Number(item.dataset.variantId)
        const quantity = Number(item.querySelector('[data-quantity-adjuster-el="input"]')?.value)

        if (!Number.isFinite(variantId) || variantId <= 0 || !Number.isFinite(quantity)) return

        if (quantity > 0) {
          const matchingCartItems = cartItems.filter((cartItem) => Number(cartItem.variant_id) === variantId)

          if (matchingCartItems.length === 0) {
            itemsToAdd.push({ id: variantId, quantity })
            return
          }

          itemsToUpdate.push({ key: matchingCartItems[0].key, quantity })
          matchingCartItems.slice(1).forEach((cartItem) => itemsToRemove.push(cartItem.key))
          return
        }

        cartItems
          .filter((cartItem) => Number(cartItem.variant_id) === variantId)
          .forEach((cartItem) => itemsToRemove.push(cartItem.key))
      })

      if (itemsToRemove.length !== 0) {
        await Promise.all(itemsToRemove.map((key) => window.BAO.Cart.updateQuantity(key, 0)))
      }

      if (itemsToUpdate.length !== 0) {
        await Promise.all(itemsToUpdate.map(({ key, quantity }) => (
          window.BAO.Cart.updateQuantity(key, quantity)
        )))
      }

      if (itemsToAdd.length !== 0) {
        await window.BAO.Cart.addItem(itemsToAdd)
      }

      window.drawers.activeDrawerKey = 'cart'
      await this.submitNote()
    } catch (error) {
      console.error('Gifting drawer save failed', error)
      throw error
    }
  }
}

customElements.define('gifting-drawer', GiftingDrawer)
